import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { settingsService } from '@/services/api/settings.service';
import type { UpdateOpsSettingsRequest } from '@/types';
import { queryKeys } from './keys';

export function useOpsSettings() {
  return useQuery({
    queryKey: queryKeys.settings.all,
    queryFn: ({ signal }) => settingsService.get(signal),
    staleTime: 60 * 1000,
  });
}

export function useUpdateOpsSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateOpsSettingsRequest) => settingsService.update(body),
    onSuccess: (settings) => {
      queryClient.setQueryData(queryKeys.settings.all, settings);
      toast.success('Settings saved.');
    },
  });
}

export function useSendTestPage() {
  return useMutation({
    mutationFn: () => settingsService.testPage(),
    onSuccess: ({ sentTo }) => {
      toast.success(`Test page sent to ${sentTo}.`);
    },
  });
}
